import {AfterContentInit, ChangeDetectionStrategy, Component, OnDestroy} from '@angular/core';
import {FormBuilder}                                                     from '@angular/forms';
import {Observable, Subscription}                                        from 'rxjs';
import {
  ApTranslationPipe
}                                                                        from '../../translation/pipes/ap-translation.pipe';
import {ApMenuUrls}                                                      from '../../ap-interface';
import {InvitationStore}                                                 from '../../stores/login/invitation.store';
import {LanguageStore}                                                   from '../../stores/translation/language.store';
import {RouterStore}                                                     from '../../stores/router/router.store';

@Component({
  selector: 'ap-invitations',
  templateUrl: 'ap-invitations.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ApInvitationsComponent implements AfterContentInit, OnDestroy {
  public confirmedSuccess$: Observable<boolean>;
  public message: string;
  public data: any;
  public showNewUser = false;
  private _subscriptions: Subscription[] = [];
  private _activationCode: number;
  private _id: number;
  private _lang: string;

  constructor(private fb: FormBuilder,
              private invitationStore: InvitationStore,
              private router: RouterStore,
              private languageStore: LanguageStore,
              private _translationPipe: ApTranslationPipe) {
  }

  ngAfterContentInit(): void {
    this.getDataFromStore();
    this._subscriptions.push(this.languageStore.Listen(s => s.data).subscribe(lang => {
      if (lang == null) {
        return;
      }
      // const foundLang = find(lang, _ => _.Key === this._lang);
      // this.languageStore.SelectLanguage(foundLang);
    }));
    this._subscriptions.push(this.invitationStore.Listen(s => s.createNewUser).subscribe(cnu => {
      if (cnu == null) {
        return;
      }
      this.showNewUser = true;
      this.data = {
        Lang: this._lang,
        ActivationCode: this._activationCode,
        Id: this._id,
        Forename: '',
        Surname: '',
        Email: '',
        Password: '',
        PasswordRepeat: ''
      };
    }));

    this._subscriptions.push(this.invitationStore.Listen(s => s.message).subscribe(m => {
      if (m == null) {
        return;
      }
      if (m !== '') {
        this.message = m;
      }
    }));

    this._subscriptions.push(this.invitationStore.Listen(s => s.isSuccessful).subscribe(d => {
      if (d == null) {
        return;
      }
      if (d) {
        this.showNewUser = false;
        this.message = 'Web_DataService__SubjectRegistrationMail';
        if (!this._id || !this._activationCode) {
          throw new Error('Invitation activate : Id or activation code is not provided');
        }
        this.invitationStore.confirmed(this._id, this._activationCode);
        setTimeout(() => {
          this.router.navigate([ApMenuUrls.LOGIN]).then(() => {
          });
        }, 5000);
      }
    }));

    this._subscriptions.push(this.router.Listen(s => s).subscribe(url => {
      if (url == null) {
        return;
      }
      this._lang = url.queryParams.lang;
      this._activationCode = parseInt(url.queryParams.ac, 10);
      this._id = parseInt(url.queryParams.id, 10);
      if (isNaN(url.queryParams.id) || isNaN(url.queryParams.ac)) {
        console.warn(`id ${this._id} or activationCode ${this._activationCode} are not a number`);
        return;
      }
      this.invitationStore.confirmed(this._id, this._activationCode);
    }));
  }

  ngOnDestroy(): void {
    this._subscriptions.forEach(s => s.unsubscribe());
  }

  getDataFromStore(): void {
    // this.languageStore.Load();
    this.confirmedSuccess$ = this.invitationStore.Listen(s => s.isSuccessful);
  }
}
